import { sleep } from "../../lib/utils";

export const refreshPage = async () => {
  await sleep(5000);
  window.location.reload();
};
